<template>
  <section class="Introduction__sns">
    <div class="inner">
      <h2 class="Head__md Introduction__sns_head">
        \ ご紹介はこちらから /
      </h2>
      <div class="Introduction__sns_area">
        <div v-show="!isPC" class="Introduction__sns_box">
          <ShareNetwork
            :popup="{width: 800, height: 800}"
            class="Introduction__sns_box_btn Introduction__sns_box_btn--cl01"
            network="line"
            :url="linkIntroduce"
            :title="lineMessage"
          >
            LINEで送る
          </ShareNetwork>
        </div>
        <div class="Introduction__sns_box">
          <ShareNetwork
            class="Introduction__sns_box_btn Introduction__sns_box_btn--cl02"
            network="email"
            url=""
            :title="emailSubject"
            :description="`${emailBody}${linkIntroduce}`"
          >
            メールで送る
          </ShareNetwork>
        </div>
        <div class="Introduction__sns_box">
          <button class="Introduction__sns_box_btn Introduction__sns_box_btn--cl03" @click.stop.prevent="copysharingCode">
            紹介用URLをコピー
            <input id="testing-code" type="hidden" :value="linkIntroduce">
          </button>
        </div>
        <div v-show="!isPC" class="Introduction__sns_box Introduction__sns_box_link_area">
          <a class="Introduction__sns_box_link Introduction__sns_box_link--insta" @click.stop.prevent="shareInstagram" />
          <ShareNetwork
            class="Introduction__sns_box_link Introduction__sns_box_link--twitter"
            network="twitter"
            :url="linkIntroduce"
            :popup="{width: 800, height: 800}"
            title="Register MelonTV"
          />
          <ShareNetwork
            class="Introduction__sns_box_link Introduction__sns_box_link--fb"
            network="facebook"
            :url="linkIntroduce"
            :popup="{width: 800, height: 800}"
            title="Register MelonTV"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { ShareNetwork } from 'vue-social-sharing'
import authService from '@/services/authService'
import platform from 'platform-detect'

export default {
  name: 'IntroductionSNS',
  components: { ShareNetwork },
  data: function() {
    return {
      linkIntroduce: '',
      emailBody: 'マインドフルネスサロン「MELONオンライン」から招待が届きました。\nストレスの多い日々。サロンのみんなと一緒に日常をマインドフルに塗り替えよう！\n\n====\n1ヶ月（4950円）が無料になるお得な特典付き！\n\n※ 登録2ヶ月目の利用料が無料となります。\n====\n\n<登録URL>\n',
      emailSubject: '最高のすっきりに出会おう。',
      lineMessage: 'マインドフルネスサロン「MELONオンライン」から招待が届きました。\nストレスの多い日々。サロンのみんなと一緒に日常をマインドフルに塗り替えよう！\n\n====\n1ヶ月（4950円）が無料になるお得な特典付き！\n\n※ 登録2ヶ月目の利用料が無料となります。\n====\n\n<登録URL>\n',
      isPC: false
    }
  },
  mounted() {
    this.getUserInfo()
    this.handleResize()
  },
  methods: {
    async getUserInfo() {
      const response = await authService.getUserInfo()
      const user_id = response.user.user.id
      this.linkIntroduce = `${window.location.origin}/member-register?user_introduce=${user_id}`
    },
    copysharingCode() {
      navigator.clipboard.writeText(this.linkIntroduce).then(() => {
        alert('コピーが完了しました。')
      }, () => {
        alert('Oops, unable to copy')
      })
    },
    async shareInstagram() {
      await navigator.clipboard.writeText(this.linkIntroduce)
      window.open('https://instagram.com', '_blank')
    },
    handleResize() {
      if (platform.ios || platform.android) {
        this.isPC = false
      } else {
        this.isPC = true
      }
    }
  }
}
</script>
